module.exports = __webpack_public_path__ + "img/bluedownarw.fc598273.svg";